<template>
  <!-- 社教活动管理 -->
  <div class="page-activity-manage">
    <!-- 列表头部 -->
    <div class="com-list-header" style="paddingRight: 0;padding-bottom: 0">
      <el-form :model="form" class="com-search-box" ref="form" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="图书名称 :" prop="name">
              <el-input v-model="form.name" placeholder="请输入图书名称"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="图书编号 :" prop="bookNo">
              <el-input v-model="form.bookNo" placeholder="请输入图书编号"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item  class="el-form-state1"  label="借阅人 :" prop="useName">
              <el-select v-model="form.useName" filterable clearable remote placeholder="请选择借阅人" :remote-method="remoteMethod" :loading="loading">
                <el-option v-for="item in userList" :key="item.userId" :label="item.userName" :value="item.userName">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="com-head-search-btns" style="bottom: 30px;top: auto">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="restList('form')">重置</el-button>
      </div>

    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column prop="user_name" label="申请借阅人" min-width="8%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="apply_time" label="申请时间" min-width="10%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="receive_time" label="领书时间" min-width="10%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="name" label="借阅书名" min-width="10%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="book_no" label="借阅图书编号" min-width="10%"></el-table-column>
          <el-table-column prop="borrow_num" label="借阅数量" min-width="7%"></el-table-column>
          <el-table-column prop="borrow_day" label="借阅天数" min-width="7%"></el-table-column>
          <el-table-column prop="return_time" label="应归还时间" min-width="7%"></el-table-column>
          <el-table-column label="状态" min-width="7%">
            <template slot-scope="scope">{{ scope.row.deferred_status | filterStatus }}</template>
          </el-table-column>
          <el-table-column prop="deferred_day" label="延期申请天数" min-width="7%"></el-table-column>

          <el-table-column fixed="right" label="操作" min-width="10%">
            <template slot-scope="scope">
              <span v-if="scope.row.deferred_status == 0">
                <a class="m-btn mr-10" @click="borrowPass(scope.row)">同意</a>
                <a class="m-btn mr-10  m-danger" @click="borrowRefuse(scope.row)">驳回</a>
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import axios from 'axios'
export default {
  components: {
  },
  computed: {
    userData() {
      return this.$store.state.user
    }
  },
  data() {
    return {
      that: this,
      form: {
        name: '',
        bookNo: '',
        userName: '',
        type: 1
      },
      loading: false,
      userList: [],
      borrowBookListt: [],
      listLoading: true,
      tableData: [],
      listQuery: {
        currentPage: 1,
        size: 10
      },
      dialogVisible: false,
      total: 0,
    }
  },

  filters: {
    filterStatus(status) {
      switch (status) {
        case '0':
          return '延期申请中'
        case '1':
          return '延期申请通过'
        case '2':
          return '不通过'
      
      }
    }
  },

  methods: {
    initData() {
      this.listLoading = true
      this.$api.book.getAdminPageList({
        ...this.form,
        deferredStatus: 1,
        ...this.listQuery
      }).then(res => {
        if (res.success) {
          this.tableData = res.result.records
          this.total = res.result.total
        }
        this.listLoading = false
      }).catch(err => {
        this.listLoading = false
      })

    },

    // 下拉框查询借阅人列表
    remoteMethod(query) {
      this.loading = true
      this.getUserInfo({ nameOrPhone: query })
    },


    // 重置
    restList(formName) {
      this.$refs[formName].resetFields()
      this.getUserInfo()
      this.listQuery.currentPage = 1
      this.initData()
    },

    //申请通过
    borrowPass(obj) {
      this.$common.confirm(
        {
          title: `是否通过${obj.user_name}延期申请？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$api.book.borrowPass({
            id: obj.id
          }).then(res => {
            if (res.success) {
              this.$message.success('延期通过')
              this.initData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    //申请拒绝
    borrowRefuse(obj) {
      this.$common.confirm(
        {
          title: `是否拒绝${obj.user_name}延期申请？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$api.book.borrowRefuse({
            id: obj.id
          }).then(res => {
            if (res.success) {
              this.$message.success('延期拒绝')
              this.initData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },


    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initData()
    },

    // 领取人列表
    getUserInfo(param) {
      this.userList = []
      this.$api.book.getUserInfo(param).then(res => {
        this.loading = false
        if (res.success) {
          this.userList = res.result
        }
      })
    },

    //取消
    handleClose() {
      this.$refs['addForm'].resetFields()
      this.dialogVisible = false
    },

    getTableList() {
      this.listQuery.currentPage = 1
      this.initData()
    },

    keydown(event) {
      if (event.keyCode == '13') {
        this.getTableList()
      }
    }
  },

  mounted() {
    this.getUserInfo()
    this.initData()

    window.addEventListener('keyup', this.keydown)

  }
}
</script>

<style lang="scss" scoped>
.com-search-box {
  /deep/ .el-col {
    margin-bottom: 30px;
  }
}

/deep/ .el-date-editor {
  width: 100%;
}

.el-form-state1{
  /deep/ .el-form-item__label{
    width: 70px !important;
  }

  /deep/ .el-form-item__content{
    margin-left: 70px !important;
  }
}
</style>